export default __webpack_public_path__ + "static/media/ai_virtual_services_photo_fr.b7fa87e3.png";